import React from 'react';

import {SkeletonBlock} from 'src/components/skeleton-block/skeleton-block';

import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {
    section,
    sections,
} from '../user-profile.module.styl';


export const UserProfileSkeleton: React.FC = () => (
    <div className={sections}>
        <div className={section}>
            <Typography variant="heading-level-4">
                <SkeletonBlock width={140} height={24}/>
            </Typography>
            <Group direction="v" gap="s">
                <SkeletonBlock width={320} height={20}/>
                <SkeletonBlock width={280} height={20}/>
                <SkeletonBlock width={220} height={20}/>
            </Group>
        </div>
        <div className={section}>
            <Typography variant="heading-level-4">
                <SkeletonBlock width={160} height={24}/>
            </Typography>
            <Group direction="v" gap="m">
                <SkeletonBlock width={220} height={20}/>
            </Group>
        </div>
    </div>
);
